import { ViewBooking } from "collins-js-sdk";
import React from "react";
import { VenueGroupConfig } from "../../../../../../../types/VenueGroup";
import { VenueConfig } from "../../../../../../../types/venues";
import { BookingLabels } from "../../RunSheetCard/BookingLabels";

interface DiaryBookingCardDetailedLabelsProps {
  booking: ViewBooking;
  venueConfig: VenueConfig;
  venueGroupConfig: VenueGroupConfig;
  showDetailedLabels?: boolean;
  isOnRunSheet?: boolean;
}

export const DiaryBookingCardDetailedLabels =
  React.memo<DiaryBookingCardDetailedLabelsProps>(
    ({
      booking,
      venueConfig,
      venueGroupConfig,
      showDetailedLabels,
      isOnRunSheet
    }) => {
      if (!showDetailedLabels) {
        return null;
      }

      return (
        <div className="DiarySidebarListItem__detailedLabels">
          <BookingLabels
            booking={booking}
            venueConfig={venueConfig}
            venueGroupConfig={venueGroupConfig}
            isOnRunSheet={isOnRunSheet}
          />
        </div>
      );
    }
  );

DiaryBookingCardDetailedLabels.displayName = "DiaryBookingCardDetailedLabels";
